import React from "react";
import PropTypes from "prop-types";
// import cx from "classnames";
import { Form, Button, Icon, Modal } from "antd";
import { OrderedMap, Map, List } from "immutable";
import { INPUT_TYPES } from "constants";
import {
    fieldGenerator,
    getValidateStatus
} from "utilities/form";
// import shortID from "uuid/v4";
import CompanyLosService from "./../services/company-los-services";
import moment from "moment";
// import { CompanyBrand } from "./../records/index";
// import moment from "moment";
const SUBVENTION_FROM = {
    1: {id: 1, name: "Invoice Date"},
    2: {id: 2, name: "Disbursal Date"}
};

const getFormFields = ({
    allFieldsDisabled,
    // tenor,
    // validateOverdueTenor
},validateOverdueTenor ) => new OrderedMap({
    id: {
        key: "id",
        label: "Id",
        dataIndex: "id",
        width: 0,
        type: INPUT_TYPES.NUMBER,
        className: "form-field d-none",
        disabled: true,
        trigger: "onBlur",
        valuePropName: "defaultValue"
    },
    date_of_agreement: {
        key: "date_of_agreement",
        label: "Date of Agreement",
        dataIndex: "date_of_agreement",
        type: INPUT_TYPES.DATE,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        // rules:[{
        //     required: true,
        //     message: "Please select a Date of Agreement"
        // }]
    },
    product: {
        key: "product",
        label: "Product",
        dataIndex: "product",
        type: INPUT_TYPES.OBJECT_SELECT,
        className: "form-field fb-50",
        // parentClass: "schemes-detail",
        disabled: allFieldsDisabled,
        labelProp: "name",
        showSearch: true,
        rules:[{
            required: true,
            message: "Please select a Product"
        }]
    },
    lending_partner: {
        key: "lending_partner",
        label: "Partner Bank",
        dataIndex: "lending_partner",
        className: "form-field fb-50",
        type: INPUT_TYPES.OBJECT_SELECT,
        showSearch: true,
        // parentClass: "schemes-detail",
        getOptionsOnFocus: CompanyLosService.getLendingPartners,
        labelProp: "name",
        rules:[{
            required: true,
            message: "Please select a Partner Bank"
        }]
    },
    channel_product: {
        key: "channel_product",
        label: "Channel Product",
        dataIndex: "channel_product",
        type: INPUT_TYPES.OBJECT_SELECT,
        className: "form-field fb-50",
        // parentClass: "schemes-detail",
        disabled: allFieldsDisabled,
        labelProp: "name",
        mode: "multiple",
        showSearch: true,
        rules:[{
            required: true,
            message: "Please select a Channel Product"
        }]
    },
    subvention_from: {
        key: "subvention_from",
        label: "Subvention From",
        dataIndex: "subvention_from",
        type: INPUT_TYPES.OBJECT_SELECT,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        labelProp: "name",
        rules:[{
            required: true,
            message: "Please enter Subvention From"
        }],
        options: [
            {id: 1, name: "Invoice Date"},
            {id: 2, name: "Disbursal Date"},
        ],
        defaultValue: SUBVENTION_FROM[2]
    },
    name: {
        key: "name",
        label: "Name",
        dataIndex: "name",
        type: INPUT_TYPES.TEXT,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        rules:[{
            required: true,
            message: "Please select a Name"
        }]
    },
    region: {
        key: "region",
        label: "Region",
        dataIndex: "region",
        type: INPUT_TYPES.OBJECT_SELECT,
        labelProp: "name",
        className: "form-field fb-50",
        // parentClass: "schemes-detail",
        showSearch: true,
        mode: "multiple",
        disabled: allFieldsDisabled,
        onSearch: str => {
            return str && str.length > 0
                ? CompanyLosService.locationLookup({
                    ["state_name"]: str
                }).then(({ data }) => ({
                    data: new List(data)
                        .toMap()
                        .mapKeys((k, _) => _.name)
                        .toList()
                        .toArray()
                }))
                : Promise.resolve({
                    data: []
                });
        },
        rules:[{
            required: true,
            message: "Please select a Region"
        }]
    },
    margin: {
        key: "margin",
        label: "Margin",
        dataIndex: "margin",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        rules:[{
            required: true,
            message: "Please enter Margin"
        }]
    },
    tenor: {
        key: "tenor",
        label: "Tenor",
        dataIndex: "tenor",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        rules:[{
            required: true,
            message: "Please enter Tenor"
        }]
    },
    overdue_tenor: {
        key: "overdue_tenor",
        label: "Overdue Interset Tenor",
        dataIndex: "overdue_tenor",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        rules:[{
            required: true,
            message: "Please enter Overdue Interest Tenor"
        },
        {
            validator: validateOverdueTenor
        }]
    },
    subvention_days: {
        key: "subvention_days",
        label: "Subvention Days",
        dataIndex: "subvention_days",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        rules:[{
            required: true,
            message: "Please enter Subvention Days"
        }]
    },
    subvention_perc: {
        key: "subvention_perc",
        label: "Subvention Percentage",
        dataIndex: "subvention_perc",
        type: INPUT_TYPES.TEXT,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        rules:[{
            required: true,
            message: "Please enter a Subvention Percentage"
        }]
    },
    roi: {
        key: "roi",
        label: "ROI",
        dataIndex: "roi",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",        
        rules:[{
            required: true,
            message: "Please enter ROI"
        }]
    },
    roi_per_day: {
        key: "roi_per_day",
        label: "ROI per day",
        dataIndex: "roi_per_day",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        rules:[{
            required: true,
            message: "Please enter ROI per day"
        }]
    },
    overdue_roi: {
        key: "overdue_roi",
        label: "Overdue ROI",
        dataIndex: "overdue_roi",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        rules:[{
            required: true,
            message: "Please enter Overdue ROI"
        }]
    },
    cashback_days: {
        key: "cashback_days",
        label: "Cashback Days",
        dataIndex: "cashback_days",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        rules:[{
            required: true,
            message: "Please enter Cashback Days"
        }]
    },
    exigency_days: {
        key: "exigency_days",
        label: "Exigency Days",
        dataIndex: "exigency_days",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        rules:[{
            required: true,
            message: "Please enter Exigency Days"
        }]
    },
    stop_billing_days: {
        key: "stop_billing_days",
        label: "Stop Billing Days",
        dataIndex: "stop_billing_days",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        rules:[{
            required: true,
            message: "Please enter Stop Billing Days"
        }]
    },
    cashback_sharing_percentage_for_dealer: {
        key: "cashback_sharing_percentage_for_dealer",
        label: "Cashback sharing % for dealer",
        dataIndex: "cashback_sharing_percentage_for_dealer",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        rules:[{
            required: true,
            message: "Please enter Cashback sharing % for dealer"
        }]
    },
    cashback_sharing_percentage_for_seller: {
        key: "cashback_sharing_percentage_for_seller",
        label: "Cashback sharing % for seller",
        dataIndex: "cashback_sharing_percentage_for_seller",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        rules:[{
            required: true,
            message: "Please enter Cashback sharing % for seller"
        }]
    },
    cooling_period: {
        key: "cooling_period",
        label: "Cooling Period",
        dataIndex: "cooling_period",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        rules:[{
            required: true,
            message: "Please enter Cooling Period"
        }]
    },
    disbursal_wait_days: {
        key: "disbursal_wait_days",
        label: "Disbursal wait days",
        dataIndex: "disbursal_wait_days",
        type: INPUT_TYPES.NUMBER,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
        rules:[{
            required: true,
            message: "Disbursal wait days"
        }]
    },
    buyer_max_limit: {
        key: "buyer_max_limit",
        label: "Buyer Max Limit",
        dataIndex: "buyer_max_limit",
        type: INPUT_TYPES.FLOAT,
        className: "form-field fb-50",
        disabled: allFieldsDisabled,
        trigger: "onBlur",
        valuePropName: "defaultValue",
    }
});


class CompanySchemeDetailsForm extends React.Component {
    state = {
        brandIds: new Map({}),
        removedBrands: [],
        addedBrands: false
    };

    // componentDidMount() {
    //     if(!this.state.brandIds.size) {
    //         this.toggleFormGrid("ADD");
    //     }
    // }

    // componentDidUpdate() {
    //     if(this.props.values && this.props.values.length && !this.state.addedBrands) {
    //         const values = new List(this.props.values)
    //             .toMap()
    //             .mapEntries(([, v]) => [v.id, v]);
    //         this.setState({
    //             brandIds: values.map((_, k) => {
    //                 return {
    //                     ..._,
    //                     date_of_agreement: _.date_of_agreement && moment(_.date_of_agreement),
    //                     key: k,
    //                     index: k
    //                 };
    //             }),
    //             addedBrands: true
    //         });
    //     }
    // }

    // toggleFormGrid = (action = "ADD", id) => {
    //     const { brandIds } = this.state;
    //     let removedBrands = this.state.removedBrands;
    //     const newID = shortID();
    //     switch (action) {
    //     case "ADD":
    //         this.setState({
    //             brandIds: brandIds.set(newID, {...new CompanyBrand().toJS(), key: newID, index: newID})
    //         });
    //         break;
    //     case "REMOVE": {
    //         removedBrands.push(id);
    //         this.setState({
    //             removedBrands: removedBrands
    //         });
    //         break;
    //     }
    //     default:
    //     }
    // };

    checkValue = (overdueTenor, tenor) => {
        if(overdueTenor < tenor){
            return false;
        } else {
            return true;
        }
    }

    validateOverdueTenor = (rule, value, callback) => {
        const { form } = this.props;
        if (value < form.getFieldsValue().tenor) {
            callback("Overdue interest tenor value must be equal or more than tenor.");
        } else {
            callback();
        }
    }


    formFields = getFormFields({ 
        allFieldsDisabled: this.props.loading, 
        tenor: this.props.form.getFieldsValue().tenor,
        // validateOverdueTenor: this.checkValue(this.props.form.getFieldsValue().overdue_tenor, this.props.form.getFieldsValue().tenor)
    }, this.validateOverdueTenor);
    fieldGenerator = fieldGenerator.bind(this.props.form);
    // getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            if(this.checkValue(this.props.form.getFieldsValue().overdue_tenor, this.props.form.getFieldsValue().tenor)){
                this.props.form.validateFields((err, values) => {
                    if (!err) {
                        let newValues = values;
                        newValues.subvention_perc = newValues.subvention_perc !== "" ? newValues.subvention_perc : null;
                        newValues.date_of_agreement = newValues.date_of_agreement && newValues.date_of_agreement.format("YYYY-MM-DD");
                        newValues.channel_product = newValues.channel_product && newValues.channel_product.map(_ => _.id);
                        newValues.product = newValues.product && newValues.product.id;
                        newValues.region = newValues.region && newValues.region.map(_ => _.id);
                        newValues.lending_partner = newValues.lending_partner && newValues.lending_partner.id;
                        newValues.subvention_from = newValues.subvention_from && newValues.subvention_from.id;
                        this.props.onValuesSubmit(newValues);
                    }
                });
            } 
        }
    }

    onSearchProducts = (val) => {
        return CompanyLosService.getChannelProducts(val).then(({data}) => {
            return {
                data
            };
        });
    }

    // tableFormCell = () => props => {
    //     const { dataIndex, record, field, ...restProps } = props;
    //     if(dataIndex === "channel_product") {
    //         field.onSearch = this.onSearchProducts;
    //     }
    //     if(dataIndex === "product") {
    //         field.getOptionsOnFocus = CompanyLosService.getProducts;
    //     }
    //     const index = record && record.index;
    //     return (
    //         <td {...restProps}>
    //             {this.fieldGenerator(
    //                 `[${index}].${dataIndex}`,
    //                 { ...field, defaultValue: record[dataIndex] },
    //                 this.getValidateStatus(dataIndex)
    //             )()}
    //         </td>);
    // }
    // tableCell = this.tableFormCell(this.props.form);
    render() {
        return (
            <Modal 
                width={800}
                bodyStyle={{
                    paddingRight: "6rem",
                    paddingLeft: "6rem"
                }}
                footer={null}
                title="Add/Update New Scheme"
                visible={this.props.visible}
                onCancel={this.props.toggleModal}
            >
                <Form onSubmit={this.onValuesSubmit}>
                    <div className={"form-row align-items-center"}>
                        {this.formFields.map((field, fieldName) => {
                            if(fieldName === "channel_product") {
                                field.onSearch = this.onSearchProducts;
                            }
                            if(fieldName === "product") {
                                field.onSearch = CompanyLosService.getProducts;
                            }
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                this.getValidateStatus(fieldName)
                            )();
                        }).toList()}
                    </div>
                    <div className={"form-row flex-row-reverse p-10"}>
                        <Button type={"primary"} htmlType={"submit"}>
                            {this.props.loading ? <Icon type={"loading"} /> : null}
                            Add/Update
                        </Button>
                        {/* <Button className={"mr-5"} onClick={this.toggleFormGrid.bind(null, "ADD")}>
                            <Icon type={"plus"} />
                            Add New
                        </Button> */}
                    </div>
                </Form>
            </Modal>
        );
    }
}

CompanySchemeDetailsForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.array,
    onValuesSubmit: PropTypes.func,
    loading: PropTypes.bool,
    visible: PropTypes.visible,
    toggleModal: PropTypes.func
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
                    values
                        .toSeq()
                        .toMap()
                        .map((value, key) => {
                            if(key === "subvention_from"){
                                value = SUBVENTION_FROM[value];
                            }
                            if(key === "date_of_agreement" && value){
                                value = moment(value);
                            }
                            let message = null;
                            if (value === null && key !== "date_of_agreement") {
                                message = "Field cannot be empty";
                            }
                            if (message) {
                                return Form.createFormField({
                                    value,
                                    errors: [{ message }]
                                });
                            } else {
                                return Form.createFormField({
                                    value
                                });
                            }
                        }).toJS();
    }
})(CompanySchemeDetailsForm);